// Generated by CoffeeScript 1.12.2
let Share_Modal;

let url_to_array;

url_to_array = require("../helpers/url_to_array").default;

let noun = window.noun;

Share_Modal = (() => {
    function Share_Modal() {
        let description;
        let encoded_url;
        let media;
        let modal_setup;
        let service;
        let url;
        url = $(".share").data("url");
        encoded_url = encodeURIComponent($(".share").data("url"));
        media = encodeURIComponent($(".share").data("media"));
        description = encodeURIComponent($(".share").data("description"));
        service = "";
        console.log(`url: ${url} media: ${media} description: ${description}`);
        modal_setup = href => {
            let height;
            let left;
            let opts;
            let setup_url;
            let top;
            let width;
            width = 575;
            height = 400;
            left = ($(window).width() - width) / 2;
            top = ($(window).height() - height) / 2;
            setup_url = href;
            opts = `status=1,width=${width},height=${height},top=${top},left=${left}`;
            return window.open(setup_url, "", opts);
        };
        $(".share-on-facebook").on("click", function(e) {
            let $share_element;
            if (noun.share_element !== void 0) {
                $share_element = noun.share_element;
                url = `https://${url_to_array[2]}${$share_element.data("url")}`;
            } else {
                url = $(".share").data("url");
            }
            service = "Facebook";
            e.preventDefault();
            this.href = "https://www.facebook.com/sharer/sharer.php";
            this.href += `?u=${url}`;
            console.log(this.href);
            return modal_setup(this.href);
        });
        $(".share-on-twitter").on("click", function(e) {
            let $share_element;
            let new_url;
            service = "Twitter";
            e.preventDefault();
            if (noun.share_element !== void 0) {
                console.log("noun.share_element isnt undefined");
                $share_element = noun.share_element;
                description = encodeURIComponent(
                    $share_element.data("description")
                );
                new_url = `https://${url_to_array[2]}${$share_element.data(
                    "url"
                )}`;
                this.href = `//twitter.com/share?text=${description}${encodeURIComponent(
                    " on the @NounProject. "
                )}&url=${new_url}`;
            } else {
                console.log("noun.share_element is undefined");
                description = encodeURIComponent(
                    $(".share").data("description")
                );
                new_url = encodeURIComponent($(".share").data("url"));
                this.href += `?text=${description}${encodeURIComponent(
                    " on the @NounProject. "
                )}&url=${new_url}`;
            }
            console.log(this.href);
            return modal_setup(this.href);
        });
        $(".share-on-tumblr").on("click", function(e) {
            let $share_element;
            service = "Tumblr";
            e.preventDefault();
            if (noun.share_element !== void 0) {
                $share_element = noun.share_element;
                encoded_url = encodeURIComponent(
                    `https://www.thenounproject.com${$share_element.data(
                        "url"
                    )}`
                );
                media = encodeURIComponent($share_element.data("media"));
                description = encodeURIComponent(
                    $share_element.data("description")
                );
                this.href = "//www.tumblr.com/share/photo";
                this.href += `?source=${media}`;
                this.href += `&caption=${description}${encodeURIComponent(
                    " on the @NounProject. "
                )}`;
                this.href += `&click_thru=${encoded_url}`;
            } else {
                encoded_url = encodeURIComponent($(".share").data("url"));
                media = encodeURIComponent($(".share").data("media"));
                description = encodeURIComponent(
                    $(".share").data("description")
                );
                this.href += `?source=${media}`;
                this.href += `&caption=${description}`;
                this.href += `&click_thru=${encoded_url}`;
            }
            return modal_setup(this.href);
        });
        $("#share-on-pinterest").on("click", function(e) {
            let $share_element;
            service = "Pinterest";
            e.preventDefault();
            if (noun.share_element !== void 0) {
                $share_element = noun.share_element;
                url = `https://${url_to_array[2]}${$(".share").data("url")}`;
                media = encodeURIComponent($share_element.data("media"));
                description = encodeURIComponent(
                    $share_element.data("description")
                );
                this.href += `?url=${url}&amp;media=${media}&amp;description=${description}`;
            } else {
                url = $(".share").data("url");
                media = encodeURIComponent($(".share").data("media"));
                description = encodeURIComponent(
                    $(".share").data("description")
                );
                this.href += `?url=${url}&amp;media=${media}&amp;description=${description}`;
            }
            return modal_setup(this.href);
        });
    }

    return Share_Modal;
})();

export default Share_Modal();
